import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || '';
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || '';

if (!supabaseUrl || !supabaseAnonKey) {
  console.error('Missing Supabase environment variables. Please check your .env file.');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

export type WaitlistEntry = {
  id?: number;
  email: string;
  name?: string;
  interests?: string;
  feature_preferences?: string;
  created_at?: string;
  validation_campaign?: string;
};

export const addToWaitlist = async (entry: Omit<WaitlistEntry, 'id' | 'created_at'>) => {
  const { data, error } = await supabase
    .from('waitlist')
    .insert([entry])
    .select();
  
  if (error) {
    throw error;
  }
  
  return data?.[0];
}; 